import { Injectable } from '@angular/core';
import { ItauDigitalAnalyticsView } from '@app-analytics/analytics';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private implementationTeam = 'experiencia-cliente:plataforma-atacado';

  constructor(private itauDigitalAnalytics: ItauDigitalAnalyticsView) {}

  initializeGA4(): void {
    const default_parameters = {
      analytics: {
        parameters: {
          business: 'plataforma-atacado',
          environment: 'logado',
          business_channel: 'plataforma-atacado'
        }
      }
    };

    this.itauDigitalAnalytics.setDefaultParameters(default_parameters);
    this.setUserProperty();
  }

  setUserProperty(): void {
    const operator = sessionStorage.getItem('operador')?.toLowerCase();
    const userProperty = {
      analytics: {
        event_name: 'user_data',
        user: {
          user_id: operator,
          operator_id: operator
        }
      }
    };

    this.itauDigitalAnalytics.setUserProperties(userProperty);
  }

  trackRoute(route: string) {
    const routeEvent = {
      analytics: {
        event_name: 'screen_view',
        parameters: {
          custom_path: route,
          implementation_team: this.implementationTeam,
          detail: `shell rota: ${route}`
        }
      }
    };

    this.itauDigitalAnalytics.track(routeEvent);
  }

  trackClick(detail: string) {
    const clickEvent = {
      analytics: {
        event_name: 'click',
        parameters: {
          custom_path: document.location.pathname.toLowerCase(),
          implementation_team: this.implementationTeam,
          detail: detail
        }
      }
    };

    this.itauDigitalAnalytics.track(clickEvent);
  }

  trackError(errorDetails: string) {
    this.itauDigitalAnalytics.track({
      analytics: {
        event_name: 'alert',
        parameters: {
          custom_path: document.location.pathname.toLowerCase(),
          implementation_team: this.implementationTeam,
          detail: errorDetails
        }
      }
    });
  }
}
